import { LaantakerWeb } from '../generated-types';

export const laantakerNavn = (laantaker: LaantakerWeb | undefined): string =>
    laantaker ? `${laantaker.fornavn}!` : '';
